
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/franchise/support",
      function () {
        return require("private-next-pages/franchise/support.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/franchise/support"])
      });
    }
  